// frontend/src/components/settings/PasswordChangeForm.tsx

import { useState, FormEvent } from 'react';
import { settingsService } from '../../services/settings.service';

export function PasswordChangeForm() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState<{ text: string; type: 'success' | 'error' } | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setMessage(null);

    if (newPassword.length < 6) {
      setMessage({ text: 'Şifre en az 6 karakter olmalı.', type: 'error' });
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage({ text: 'Şifreler eşleşmiyor.', type: 'error' });
      return;
    }

    setIsSaving(true);
    try {
      await settingsService.changePassword(newPassword);
      setMessage({ text: 'Şifre değiştirildi! ✅', type: 'success' });
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setMessage({ text: err instanceof Error ? err.message : 'Şifre değiştirilemedi.', type: 'error' });
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <div className="card" style={{ marginTop: 24 }}>
      <h3 className="parent-section-title">Şifre Değiştir</h3>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-2">
          <div className="form-group">
            <label>Yeni Şifre</label>
            <input
              className="input"
              type="password"
              placeholder="••••••••"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Yeni Şifre (Tekrar)</label>
            <input
              className="input"
              type="password"
              placeholder="••••••••"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
        </div>

        {message && (
          <p className={message.type === 'success' ? 'auth-info' : 'auth-error'} style={{ marginBottom: 12 }}>
            {message.text}
          </p>
        )}

        <button type="submit" className="lesson-btn primary" disabled={isSaving}>
          {isSaving ? '⏳ Güncelleniyor...' : '🔐 Şifreyi Güncelle'}
        </button>
      </form>
    </div>
  );
}
